const professions = [
  {
    id: 1,
    name: "Doctor",
    slug: "doctor",
    types: [101, 102],
    cardName: "General Practitioner",
  },
  {
    id: 101,
    name: "General Practitioner",
    slug: "doctor-general-practitioner",
    cardName: "General Practitioner",
    list: ["Doctor-General Practicioner"],
  },
  {
    id: 102,
    name: "Specialist",
    slug: "doctor-specialist",
    isSpecialist: true,
    cardName: "Doctor Specialist",
    list: ["Doctor-Specialist"],
  },
  {
    id: 5,
    name: "Nurse",
    slug: "nurse",
    types: [501, 502, 503],
    cardName: "Nurse",
  },
  {
    id: 501,
    name: "Staff Nurse",
    slug: "nurse-staff-nurse",
    cardName: "Staff Nurse",
    list: ["Nurse-Nurse"],
  },
  {
    id: 502,
    name: "Senior Staff Nurse",
    slug: "nurse-senior-staff-nurse",
    cardName: "Senior Staff Nurse",
    list: ["Nurse-Nurse"],
  },
  // {
  //   id: 503,
  //   name: "Head of Nurses",
  //   slug: "nurse-head-of-nurses",
  //   cardName: "Head of Nurses",
  //   list: ["Nurse-Nurse"],
  // },
  {
    id: 2,
    name: "Dentist",
    slug: "dentist",
    types: [201, 202],
    cardName: "Dentist",
  },
  {
    id: 201,
    name: "General Dentist",
    slug: "dentist-general-dentist",
    cardName: "General Dentist",
    list: ["Dentist-General Dentist"],
  },
  {
    id: 202,
    name: "Specialist",
    slug: "dentist-specialist",
    isSpecialist: true,
    cardName: "Dentist Specialist",
    list: ["Dentist-Specialist"],
  },
  {
    id: 3,
    name: `Dental\nAssistant`,
    slug: "dentist-assistant",
    isSpecialist: true,
    cardName: "Dental Assistant",
    list: ["Dentist-General Dentist", "Dentist-Specialist"],
  },
  {
    id: 4,
    name: `Medical\nAssistant`,
    slug: "medical-assistant",
    cardName: ["Medical Assistant"],
    list: ["General-Medical Assistant"],
  },
  {
    id: 6,
    name: `Clinic\nAssistant`,
    slug: "general-clinic-assistant",
    cardName: "Clinic Assistant",
    list: ["General-Clinic Assistant"],
  },
  {
    id: 7,
    name: `Radiographer`,
    slug: "general-radiographer",
    cardName: "Radiographer",
    list: ["General-Radiographer"],
  },
  {
    id: 8,
    name: `Sonographer`,
    slug: "general-sonographer",
    cardName: "Sonographer",
    list: ["General-Sonographer"],
  },
  {
    id: 9,
    name: `Pharmacist`,
    slug: "general-pharmacist",
    cardName: "Pharmacist",
    list: ["General-Pharmacist"],
  },
  {
    id: 10,
    name: `Technician`,
    slug: "general-technician",
    cardName: "Technician",
    list: ["General-Technician"],
  },
  {
    id: 11,
    name: `Technologist`,
    slug: "general-technologist",
    cardName: "Technologist",
    list: ["General-Technologist"],
  },
  {
    id: 12,
    name: `Laboratory Personnel`,
    slug: "general-lab",
    cardName: "Laboratory Personnel",
    list: ["General-Lab"],
  },
  {
    id: 13,
    name: `Physiotherapist`,
    slug: "general-physiotherapist",
    cardName: "Physiotherapist",
    list: ["General-Physiotherapist"],
  },
  {
    id: 14,
    name: `Allied Health Professional`,
    slug: "general-allied-health-professional",
    cardName: "Allied Health Professional",
    list: ["General-Allied Health Professional"],
  },
];

export const isAssistant = (id) => [3, 4, 6, 7, 8, 9, 10, 11, 12].includes(id);

export const isNurses = (id) => id >= 500 && id < 600;

export const jobTypes = [
  {
    id: 0,
    icon: "locum",
    name: "Locum",
    description: "Short-term or ad hoc roles to fill in for absent staff or cover immediate needs. Can range from single to multiple.",
  },
  {
    id: 1,
    icon: "fulltime",
    name: "Full-Time",
    description: "Ongoing employment with a healthcare facility, considered permanent or long-term employment.",
  },
  {
    id: 4,
    icon: "international",
    name: "International",
    description: "Job opportunities in countries outside of your current location. Includes positions requiring relocation or remote work across borders.",
  },
  {
    id: 2,
    icon: "fulltime",
    name: "Temporary",
    description: "Non-permanent roles with a fixed duration, typically planned in advance. May last for a set period of  time with a defined schedule.",
  },
  {
    id: 3,
    icon: "fulltime",
    name: "Contract",
    description: "Fixed-duration roles with a formal agreement outlining start and end dates. Typically arranged in advance with defined responsibilities and set hours.",
  },
 
];
export const isFullTimeJob = (type) => {
  let t = parseInt(type);
  return [-2, 1, 2, 3, 4].includes(t);  
}  

export default professions;
